import * as React from "react"
import {useEffect} from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, MARKETPLACES_ROUTES} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import {isLoadingCommonFilters, isSystemBusy} from "@signals"
import {elementsInLoading, marketplacesLBBOverviewIsEmpty} from "./signals"

export default function MarketplacesLBBOverviewFilters() {

	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(MARKETPLACES_ROUTES.LBBOVERVIEW_ID, MARKETPLACES_ROUTES.ACCESS_KEY)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

	useEffect(() => {
		if (elementsInLoading.value.length < 1) batch(() => {
			isLoadingCommonFilters.value = false
		})
	}, [elementsInLoading.value.length])

	return <Box data-tour="lbb-overview-filters">
	<CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			sku: true, favFilters: true,
			favFiltersOnlyLine: true, skuGroup: true
		}}
		compProps={{
			favFilters: {
				grid: { md: 3 },
				allowedFilters: [
					COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
					COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU
				],
				dashboardKey: MARKETPLACES_ROUTES.LBBOVERVIEW_ID
			},
			sku: { grid: { md: 6 } },
			country: { filters: { websiteType: "2" } },
			site: { filters: { websiteType: "2" } }
		}}
		onSubmit={() => {
			marketplacesLBBOverviewIsEmpty.value = false
			isSystemBusy.value = false
			isLoadingCommonFilters.value = true
		}}
		defaultValues={userFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
	/>
	</Box>
}
